import PageShell from '@/components/feature/PageShell';
import StoryAndPhilosophy from './components/StoryAndPhilosophy';
import TeamGrid from './components/TeamGrid';
import ValuesCta from './components/ValuesCta';

export default function About() {
  return (
    <PageShell
      title="About Us | Our Team & Philosophy | Morrow People"
      description="Meet the advisors behind Morrow People and discover the philosophy and values that guide our independent HR and talent advisory practice."
    >
      <StoryAndPhilosophy />
      <TeamGrid />
      <ValuesCta />
    </PageShell>
  );
}